import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HelpIcon } from '../icons';
import React, { useEffect, useRef, useState } from 'react';
const HelpTip = ({ label, children }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        if (!open)
            return;
        const onPointerDown = (event) => {
            if (!ref.current?.contains(event.target))
                setOpen(false);
        };
        const onKeyDown = (event) => {
            if (event.key === 'Escape')
                setOpen(false);
        };
        document.addEventListener('mousedown', onPointerDown);
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('mousedown', onPointerDown);
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [open]);
    return (_jsxs("span", { className: 'cfg__help', ref: ref, children: [_jsx("button", { className: 'cfg__help-btn', "aria-label": label, "aria-expanded": open, onClick: () => setOpen((previous) => !previous), children: _jsx(HelpIcon, {}) }), open && (_jsx("span", { className: 'cfg__help-tip', role: 'tooltip', children: children }))] }));
};
export default React.memo(HelpTip);
